export { Skeleton, skeletonVariants, type SkeletonProps } from './Skeleton'
